import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";
import MediaUploadVideo from "./MediaUploadVideo";
import MediaUploadVideoList from "./MediaUploadVideoList";

const MediaVideoManager = () => {
    const [showModal, setShowModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [actionType, setActionType] = useState("");

    const handleUploadSuccess = () => {
        setShowModal(false);
        setRefreshList(prev => !prev);
    };
    const handleAction = (type, video) => {
        setActionType(type);
        setSelectedVideo(video);
        setShowModal(true);
    };


    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center m-4">
                <h4 className="mb-0">Video Manager</h4>
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        setActionType("add");
                        setSelectedVideo(null);
                        setShowModal(true);
                    }}
                >
                    + Add Video
                </button>

            </div>

            <MediaUploadVideoList onAction={handleAction} />

            {showModal && (
                <>
                    <div className="modal fade show" style={{ display: "block" }}>
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title text-capitalize">
                                        {actionType === "add" ? "Add Video" : `${actionType} Video`}
                                    </h5>
                                    <button className="btn-close" onClick={() => setShowModal(false)} />
                                </div>

                                <div className="modal-body">

                                    {actionType === "add" && (
                                        <MediaUploadVideo onSuccess={handleUploadSuccess} />
                                    )}

                                    {actionType === "view" && (
                                        <pre>{JSON.stringify(selectedVideo, null, 2)}</pre>
                                    )}

                                    {actionType === "edit" && (
                                        <MediaUploadVideo
                                            editData={selectedVideo}
                                            onSuccess={handleUploadSuccess}
                                        />
                                    )}

                                    {actionType === "delete" && (
                                        <>
                                            <p>Are you sure you want to delete this video?</p>
                                            <button
                                                className="btn btn-danger"
                                                onClick={async () => {
                                                    try {
                                                        await axios.delete(
                                                            `${REACT_APP_API_URL}api/dashboard/admin/delete-video/${selectedVideo.intVideoID}`
                                                        );
                                                        setShowModal(false);
                                                        setRefreshList(p => !p);
                                                    } catch (err) {
                                                        console.error(err);
                                                        alert("Delete failed (Server error)");
                                                    }
                                                }}
                                            >
                                                Yes, Delete
                                            </button>
                                        </>
                                    )}

                                    {actionType === "status" && (
                                        <button
                                            className="btn btn-warning"
                                            onClick={async () => {
                                                await axios.put(
                                                    `${REACT_APP_API_URL}api/dashboard/admin/video-status/${selectedVideo.intVideoID}`,
                                                    { bitStatus: selectedVideo.bitStatus === 1 ? 0 : 1 }
                                                );
                                                setShowModal(false);
                                                setRefreshList(p => !p);
                                            }}
                                        >
                                            Toggle Status
                                        </button>
                                    )}

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )}
        </div>
    );
};

export default MediaVideoManager;
